export default "__VITE_ASSET__Bw_cg1L7__"